require('./payrollLoanRequestStepThree.scss');
require('./payrollLoanRequestStepThreeCC.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @components
const { formatText, FormattedText } = require('core/i18n').i18n;
const PayrollLoanRequestUpload = require('../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestUpload/payrollLoanRequestUpload');
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');

// @constants
const { findPurposeById } = require('../../../contractPayrollLoan/payrollLoanPurposes');

// @Contact Center
const WebappRender = require('components/conditionalRender/webappRender');
const { NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES } = require("constants/flagBasedFeatures");
const { NOT } = require("loansConstants/index");
class PayrollLoanRequestStepThree extends React.Component {
    componentDidMount() {
        this.props.resetUploadConfig();
        this.props.loadFilesPersonalLoan();
    }

    buildTitle() {
        const {
            immPayrollLoanRequest,
            isDragoFeature,
            showPurposeTitle,
        } = this.props;

        let finalText = formatText('payrollLoanRequestStepThree-genericRequestMessage');
        if (isDragoFeature) {
            const purposeElement = immPayrollLoanRequest.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immPayrollLoanRequest.get('selectedPurposeDrago'));
            const purposeSucessText = !!purposeElement ? purposeElement.get('text') : '';
            finalText += ' ' + purposeSucessText;
        } else {
            const selectedPurpose = immPayrollLoanRequest.get('selectedPurpose');
            const purpose = findPurposeById(selectedPurpose);

            if (!!purpose && showPurposeTitle) {
                const translationKey = purpose.stepThreeTransKey || '';
                if (!!translationKey) {
                    finalText += formatText(translationKey);
                }
            }
        }

        return (
            <div className="payroll-loan-request-step-three__title">
                {finalText}
            </div>
        );
    }

    buildUploadMaxSizeText() {
        return (
            <div>
                <WebappRender>
                    <FormattedText
                        value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadMaxSizeParagraph1"
                        className="payroll-loan-request-step-three__caveat-text"
                    />
                </WebappRender>
                <div>
                    <ul>
                        <li>
                            <FormattedText
                                value="payrollLoanRequestStepThree-uploadMaxSizeParagraph2"
                                className="payroll-loan-request-step-three__caveat-text"
                            />
                            <FormattedText
                                value="payrollLoanRequestStepThree-uploadSizeText"
                                className="payroll-loan-request-step-three__bold"
                            />
                        </li>
                        <li>
                            <FormattedText
                                value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadMaxSizeParagraph3"
                                className="payroll-loan-request-step-three__caveat-text"
                            />
                            <FormattedText
                                value="payrollLoanRequestStepThree-uploadMaxSizeExtensionsText"
                                className="payroll-loan-request-step-three__bold"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    render() {
        const title = this.buildTitle();
        const {
            immPayrollLoanRequest,
            loadFileInUpload,
            clearErrorsFile,
            removeUploadedFile,
            recordStatus,
            handlerEditFileName,
            immFlagBasedFeatures,
            immPrinter
        } = this.props;

        const mailto = formatText('payrollLoanRequestStepThree-mailTo');
        const almostDone = (
            <p>
                <FormattedText
                    value="payrollLoanRequestStepThree-almostDoneUploadFromWebOrMail"
                    className="payroll-loan-request-step-three__message"
                />
                <a
                    className="ok-link payroll-loan-request-step-three__mail-to"
                    href={`mailto:${mailto}`}
                    target="_blank"
                >
                    {mailto}
                </a>
            </p>
        );

        const maxSizeTextAllowedText = this.buildUploadMaxSizeText();
        const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
        const documentPrinterAndConfirm = immPrinter.get('documentsPrintedAndSigned')
        return (
            <div className="payroll-loan-request-step-three">
                {title}
                {__CONTACT_CENTER__ ? almostDone : <FormattedText
                    value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_almostDone"
                    className="payroll-loan-request-step-three__message"
                />}
                {maxSizeTextAllowedText}
                <div className="payroll-loan-request-step-three__upload">
                    <PayrollLoanRequestUpload
                        clearErrorsFile={clearErrorsFile}
                        removeUploadedFile={removeUploadedFile}
                        immPayrollLoanRequest={immPayrollLoanRequest}
                        loadFileInUpload={loadFileInUpload}
                        recordStatus={recordStatus}
                        handlerEditFileName={handlerEditFileName}
                    />
                </div>
                <div className="payroll-loan-request-step-three__radio-button-upload">

                    {!newPayrollLoanFF && <PrinterPreviewManager />}
                    {documentPrinterAndConfirm === NOT &&
                        <p className="payroll-loan-request-step-three__document-printer-text" >{formatText(`hireCardOpenCreditStepINE-radioButtonNotSelected`)}</p>
                    }

                </div>

            </div>
        );
    }
}

PayrollLoanRequestStepThree.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    immPayrollLoanRequest: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    showPurposeTitle: PropTypes.bool,
    recordStatus: PropTypes.string.isRequired,
    resetUploadConfig: PropTypes.func.isRequired,
    loadFilesPersonalLoan: PropTypes.func.isRequired
};

module.exports = PayrollLoanRequestStepThree;
